<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <div style="padding: 5px 0;">
            <el-button size="mini" type="primary" @click="add">新增</el-button>
            <el-button size="mini" type="primary" @click="onSubmit">保存</el-button>
            <el-button size="mini" type="primary" @click="getDataList">刷新</el-button>
        </div>
        <el-table size="mini" :data="returnData.list" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="grossLevel" label="等级名称">
                <template slot-scope="scope">
                    <el-input type="text" v-model.trim="scope.row.grossLevel"></el-input>
                </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip min-width="120" prop="minGross" label="最低毛利率">
                <template slot-scope="scope">
                    <el-input @mousewheel.native.prevent type="number" v-model="scope.row.minGross"></el-input>
                </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip width="120" label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="del(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        //这里存放数据
        return {

            returnData: {
                list: [],
            },

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // "returnData.list": {
        //     handler: function (newValue, oldValue) {
        //         newValue.forEach(element => {
        //             element.minGross = this.$common.updataNum('minGross', element).minGross
        //         });
        //     },
        //     deep: true
        // }
    },
    //方法集合
    methods: {
        add() {
            this.returnData.list.push({
                grossLevel: "",
                minGross: "",
                maxGross: 0,
                sort: this.returnData.list.length + 1
            })
        },
        del(index) {
            this.returnData.list.splice(index, 1)
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.deraGrossRulequeryGrossRule();
            if (responseData.status == 200) {
                this.returnData.list = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async onSubmit() {
            if (this.returnData.list.length > 0) {
                if (this.returnData.list.some(item => item.grossLevel == "")) {
                    return this.$message({
                        message: "等级名称不能空",
                        type: "error",
                    });
                }
                console.log(this.returnData.list.filter(item => item.minGross === ""||item.minGross==null).length);
                
                if (this.returnData.list.filter(item => item.minGross === ""||item.minGross==null).length != 1) {
                    return this.$message({
                        message: "请存在一个默认为空的最低毛利率",
                        type: "error",
                    });
                }
            }
            let responseData = await this.$http.deraGrossRulesaveGrossRule({
                detailList: this.returnData.list.map(item => {
                    return {
                        grossLevel: item.grossLevel,
                        minGross: item.minGross == null ? "" : item.minGross,
                    }
                })
            });
            if (responseData.status == 200) {
                this.$message({
                    message: responseData.message,
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>